'use client';

import type { Tournament } from '@/types/tournament';
import { PastTournaments } from './PastTournaments';
import { TournamentBanner } from './TournamentBanner';

export function TournamentsList({
  activeTournaments,
  pastTournaments,
}: {
  activeTournaments: Tournament[];
  pastTournaments: Tournament[];
}) {
  return (
    <div className="space-y-6">
      <ActiveTournaments tournaments={activeTournaments} />
      <PastTournaments tournaments={pastTournaments} />
    </div>
  );
}

function ActiveTournaments({ tournaments }: { tournaments: Tournament[] }) {
  if (tournaments.length === 0) {
    return null;
  }

  return (
    <header className="space-y-6">
      <h1 className="font-bold text-2xl">Available Tournaments</h1>

      {tournaments.map((tournament) => (
        <TournamentBanner key={tournament.id} tournament={tournament} />
      ))}
    </header>
  );
}
